import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Route, Router } from '@angular/router';
import { AsyncSubject, BehaviorSubject, forkJoin, Observable, of } from 'rxjs';
import { catchError, filter, tap } from 'rxjs/operators';
import { ShopService } from '../api/shop.service';
import { DynamicElement } from '../interfaces/custom/dynamic_element';
import { MyTidyStyleGroup } from '../interfaces/custom/MyTidyBase';
import { AdminService } from './custom/admin.service';
import { HoverService } from './hover.service';

@Injectable({
  providedIn: 'root'
})
export class MyTidyConfigService {
  dragAndDrop$ : BehaviorSubject<any>;
  dragOverAsyncSubject$ : AsyncSubject<Observable<any>>;
  drop$: BehaviorSubject<any>;

  constructor(private http: HttpClient, private shop : ShopService, private adminService : AdminService, private hoverService : HoverService,
    private router : Router) {
    if (parent.window._frameLoaded) {
      parent.window._configService = this;
      parent.window._hoverService = this.hoverService;
      parent.window._frameLoaded.next(true);
      parent.window._frameLoaded.complete();
      this.adminService.liveEdit = true;

      this.dragAndDrop$ = parent.window._dragAndDrop;

      this.dragAndDrop$.subscribe(r => {
        if (r === null)
          return;

        if (r == 'drag start') {
          this.isDragging = true;
          return;
        }

        if (typeof r == 'object') {
          this.isDragging = false;
          return;
        }

      });

      this.dragOverAsyncSubject$ = parent.window._dragOver$;
      this.drop$ = parent.window._drop$;

      this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(event => {
        parent.window._updateDropHandler();
        this.drop$ = parent.window._drop$;
      });
      
    }
  }

  isDragging = false;

  config;

  getConfig(): Observable<DynamicElement[]> {
    return this.shop.getLayout().pipe(
      catchError(err => {
        // try {
        //   this.config = JSON.parse(localStorage.getItem('config'));
        //   if (!this.config)
        //     throw 'err config';
    
        //   return of(this.config);
        // } catch (err) {
          return of([]);
        // }
      }),
      tap(config => {
        if (config) {
          this.config = config;
          // localStorage.setItem('config', JSON.stringify(config));
        }
      })
    );
  }

  nextConfig$ = new BehaviorSubject(null);

  openConfig(componentClass) {
    this.nextConfig$.next({
      props: componentClass.dataProps,
      styles: Object.values(componentClass.dataStyles),
      config: componentClass._config,
      class: componentClass
    });
  }

  allStyleGroups : {[key: string]: {[key2: string]: MyTidyStyleGroup}} = {};

  registerStyles(guid, styleGroup) {
    this.allStyleGroups[guid] = styleGroup;
  }

  unregisterStyles(guid) {
    delete this.allStyleGroups[guid];
  }

  saveConfig() {
    localStorage.setItem('config', JSON.stringify(this.config));

    const combainStylesForCSS = (styles : {[key:string]: MyTidyStyleGroup}) => {
      let css = {};
      for (let style of Object.values(styles)) {
        css = {...css, ...style.getValueForStyleSheet() }
      }
      return css;
    }

    let css = [];
    for (let [key, value] of Object.entries(this.allStyleGroups)) {
      css.push({
        guid: key,
        styles: combainStylesForCSS(value)
      });
    }

    return forkJoin([
      this.shop.setLayout(this.config),
      this.shop.setCSS(css)
    ]);

  }

  removeSection(config) {
    const idx = this.config.indexOf(config);
    if (idx != -1) {
      this.config.splice(idx, 1);
    }
  }

}
